import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useLayoutEffect, useState } from 'react';
import { ThemeProvider as EmotionThemeProvider } from 'emotion-theming';
import { CacheProvider } from '@emotion/core';
import createCache from '@emotion/cache';
import merge from 'deepmerge';
import defaultTheme from '../system/default-theme';
import { flattenPalette } from '../system';
import { objectToCSSProperties, shallowEqual } from '../utils';
import { setRootStyles, styleReset } from './styles';
var STORAGE_KEY = 'ui-kit-theme';
export var cache = createCache({
  key: 'uikit',
  prefix: function prefix(key) {
    switch (key) {
      case 'appearance':
      case 'user-select':
      case 'position':
      case ':placeholder':
        return true;

      default:
        return false;
    }
  }
});
export var themeStorage = {
  get: function get() {
    return window.localStorage.getItem(STORAGE_KEY);
  },
  set: function set(value) {
    return window.localStorage.setItem(STORAGE_KEY, value);
  }
};
export var themeInitializerScript = "\ntry {\n  var theme = window.localStorage.getItem('" + STORAGE_KEY + "')\n  if (theme) {\n    document.body.dataset.theme = theme\n  }\n} catch (e) {}\n";
var emptyTheme = {};

function mergeThemes(a, b) {
  var _a$button, _b$button, _a$spinner, _b$spinner, _a$spinner2, _b$spinner2;

  if (a === void 0) {
    a = {};
  }

  if (b === void 0) {
    b = {};
  }

  return _objectSpread(_objectSpread(_objectSpread({}, a), b), {}, {
    button: _objectSpread(_objectSpread(_objectSpread({}, a.button), b.button), {}, {
      themes: merge(((_a$button = a.button) == null ? void 0 : _a$button.themes) || {}, ((_b$button = b.button) == null ? void 0 : _b$button.themes) || {})
    }),
    colors: merge(flattenPalette(a.colors || {}), flattenPalette(b.colors || {})),
    spinner: _objectSpread(_objectSpread(_objectSpread({}, a.spinner), b.spinner), {}, {
      sizes: merge(((_a$spinner = a.spinner) == null ? void 0 : _a$spinner.sizes) || {}, ((_b$spinner = b.spinner) == null ? void 0 : _b$spinner.sizes) || {}),
      thickness: merge(((_a$spinner2 = a.spinner) == null ? void 0 : _a$spinner2.thickness) || {}, ((_b$spinner2 = b.spinner) == null ? void 0 : _b$spinner2.thickness) || {})
    })
  });
}

export function ThemeProvider(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? emptyTheme : _ref$theme,
      children = _ref.children;

  var _useState = useState(function () {
    return mergeThemes(defaultTheme, theme);
  }),
      mergedTheme = _useState[0],
      setMergedTheme = _useState[1];

  useLayoutEffect(function () {
    var nextTheme = mergeThemes(defaultTheme, theme);
    setRootStyles(objectToCSSProperties('colors', nextTheme.colors));

    if (!shallowEqual(mergedTheme, nextTheme)) {
      setMergedTheme(nextTheme);
    }
  }, [theme]);
  return /*#__PURE__*/React.createElement(CacheProvider, {
    value: cache
  }, /*#__PURE__*/React.createElement(EmotionThemeProvider, {
    theme: mergedTheme
  }, children));
}
ThemeProvider.cache = cache;
ThemeProvider.setRootStyles = setRootStyles;
ThemeProvider.styleReset = styleReset;
ThemeProvider.themeInitializerScript = themeInitializerScript;
ThemeProvider.themeStorage = themeStorage;
export { setRootStyles, styleReset };